import React, { useEffect, useState } from "react";
import "../../styles/Landing.css";
import "../../styles/pages/Demo.css";
import "../../styles/solutions/ChatbotSolution.css";


import SolutionsSidebar from "../commons/SolutionsBar";
import TopBar from "../commons/TopBar";
import ChatbotSolution from "../solutions/ChatbotSolution";

export default function Demo() {
  const [selectedSolution, setSelectedSolution] = useState("chatbot");
  const [historyOpen, setHistoryOpen] = useState(false);

  const [soonModal, setSoonModal] = useState({ open: false, label: "" });
  const openSoon = (label) => setSoonModal({ open: true, label });
  const closeSoon = () => setSoonModal({ open: false, label: "" });

  const isChatbot = selectedSolution === "chatbot";

  useEffect(() => {
    const prevOverflow = document.body.style.overflow;
    const prevOverscroll = document.body.style.overscrollBehavior;

    document.body.style.overflow = "hidden";
    document.body.style.overscrollBehavior = "none";

    return () => {
      document.body.style.overflow = prevOverflow;
      document.body.style.overscrollBehavior = prevOverscroll;
    };
  }, []);

  const onSelectSolution = (solution) => {
    setSelectedSolution(solution.id);
    if (solution.soon) openSoon(solution.label);
  };

  return (
    <div className="alx-root demo-root">
      <div className="alx-bg-img" aria-hidden="true" />
      <div className="alx-bg-scrim" aria-hidden="true" />

      <TopBar
        isChatbot={isChatbot}
        onOpenHistory={() => setHistoryOpen(true)}
        onOpenSoon={openSoon}
      />

      <div className="demo-shell">
        <SolutionsSidebar
          selectedSolutionId={selectedSolution}
          onSelectSolution={onSelectSolution}
        />

        <ChatbotSolution
          selectedSolution={selectedSolution}
          historyOpen={historyOpen}
          setHistoryOpen={setHistoryOpen}
        />
      </div>

      {soonModal.open && (
        <div className="arena-modal" role="dialog" aria-modal="true" aria-labelledby="soon-title">
          <div className="arena-modal-box">
            <h3 id="soon-title">{soonModal.label}</h3>
            <p>Cette section sera disponible très bientôt. Merci pour votre patience ! 🚧</p>
            <button className="arena-primary arena-modal-close" onClick={closeSoon}>
              OK
            </button>
          </div>
          <button className="arena-modal-backdrop" aria-label="Fermer" onClick={closeSoon} />
        </div>
      )}
    </div>
  );
}